module.exports = __webpack_public_path__ + "img/articles_grey.c5a76c98.svg";